export default __webpack_public_path__ + "static/media/icon-completed.d7d2feea.svg";